import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { injectService } from '@patsnap/tahiti-core';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { PermissionV2Service } from '@telecom/shared/domain/permission/services/permission-v2-service';

/**
 * 根据当前路由同步任务所有权权限。
 */
export function useTaskPermissionSync() {
    const route = useRoute();
    const currentTaskService = injectService<CurrentTaskService>(CurrentTaskService);
    const permissionV2Service = injectService<PermissionV2Service>(PermissionV2Service);
    let lastTaskContextKey: string | undefined;

    const refresh = async () => {
        const taskId = currentTaskService.taskId;
        const taskType = currentTaskService.taskType;
        await permissionV2Service.refreshTaskPermission({ taskId, taskType });
    };

    watch(
        () => route.fullPath,
        () => {
            const taskId = currentTaskService.taskId;
            const taskType = currentTaskService.taskType;
            const taskContextKey = `${taskType}:${taskId}`;
            if (taskContextKey === lastTaskContextKey) {
                return;
            }

            lastTaskContextKey = taskContextKey;
            void refresh();
        },
        { immediate: true },
    );

    return {
        refresh,
    };
}
